export const routes = {
  importUsers: {
    path: "/users/import",
    name: "importUsers",
  },
};
